import { css } from '@emotion/react';
import Themes from '@impargo/components/Themes';
import emotionReset from 'emotion-reset';
export default css `
  ${emotionReset}
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    box-sizing: border-box;
  }
  body {
    line-height: 1;
    padding: 0;
    margin: 0;
    background-color: #f5f5f5;
    overflow: hidden;
    font-size: 14px;
    font-family: ${Themes.Impargo.fontFamily};
    height: 100%;
    .sortable-helper {
      z-index: 101;
    }
  }
  .ReactModal__Content {
    display: flex;
    flex-direction: column;
  }
  .ReactModal__Content section {
    flex: 1;
  }
  .ReactModalPortal .ReactModal__Overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    overflow: auto;
  }
  .ReactModal__Content_after-open {
    overflow: auto;
    max-height: 98vh;
  }
  @media only screen and (max-width: 960px) {
    body {
      overflow: visible;
      position: relative;
      -webkit-overflow-scrolling: touch;
    }
  }
  html {
    font-size: ${Themes.Impargo.fontSizeBody};
    height: 100%;
  }
  .app-container {
    height: 100%;
  }
  a {
    text-decoration: none;
  }
`;
